(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.now_teasers = {
    attach: function(context, settings) {
      const nowTeasersInit = function() {
        /**
         *  Emulate a button / link, but actually click the title link.
         * This removes the redundancy of each element being a link,
         * and allows more flexibility with individual elements.
         */
        jQuery('.read-more-link.faux-link').click(function(e) {
          const $moreLink = jQuery(e.target);
          const $node = $moreLink.closest('.node');
          const $link = $node.find('.node-title a');
          $link[0].click();
        });
      };
      nowTeasersInit();
    }
  };
})(jQuery, Drupal);
